import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaGoogle } from "react-icons/fa";

function TopBar() {
  return (
    <div className="bg-[#c35459ff] text-white text-sm">
      {/* Container aligned with NavBar */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-12">
        
        {/* LEFT */}
        <div className="flex gap-5">
          <span>📞 +91 78149 55755</span>
          <span>📧 info@securewebhosting.co.in</span>
        </div>

        {/* RIGHT */}
        <div className="flex gap-4 items-center">
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebookF size={16} />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={16} />
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
            <FaLinkedinIn size={16} />
          </a>
          <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">
            <FaGoogle size={16} />
          </a>
        </div>

      </div>
    </div>
  );
}

export default TopBar;